import React, { useMemo } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { longDateString } from "../../utils";
import "../../starek.css";

function PartsListingView({
    items,
    selectedRows,
    onSelectedRowsChange,
    filterText,
}) {
    const isPartSelected = (partId) => {
        return selectedRows.some((row) => row.id === partId);
    };

    const handleCheckboxChange = (part) => {
        let newSelectedRows;
        if (isPartSelected(part.id)) {
            newSelectedRows = selectedRows.filter((row) => row.id !== part.id);
        } else {
            newSelectedRows = [...selectedRows, part];
        }
        if (onSelectedRowsChange) {
            onSelectedRowsChange({ selectedRows: newSelectedRows });
        }
    };

    const filteredItems = useMemo(() => {
        const q = filterText?.trim().toLowerCase();
        if (!q) return items;
        return items.filter(
            (item) =>
                item.name?.toLowerCase().includes(q) ||
                item.description?.toLowerCase().includes(q)
        );
    }, [items, filterText]);

    const columns = [
        {
            name: (
                <input
                    type="checkbox"
                    aria-label="Select all"
                    onChange={(e) => {
                        if (e.target.checked) {
                            if (onSelectedRowsChange) {
                                onSelectedRowsChange({
                                    selectedRows: [...filteredItems],
                                });
                            }
                        } else {
                            if (onSelectedRowsChange) {
                                onSelectedRowsChange({ selectedRows: [] });
                            }
                        }
                    }}
                    checked={
                        filteredItems.length > 0 &&
                        filteredItems.every((row) => isPartSelected(row.id))
                    }
                    ref={(el) => {
                        if (!el) return;
                        const some = filteredItems.some((r) =>
                            isPartSelected(r.id)
                        );
                        const all =
                            filteredItems.length > 0 &&
                            filteredItems.every((r) => isPartSelected(r.id));
                        el.indeterminate = some && !all;
                    }}
                />
            ),
            width: "60px",
            center: true,
            sortable: false,
            cell: (row) => (
                <input
                    type="checkbox"
                    checked={isPartSelected(row.id)}
                    onChange={() => handleCheckboxChange(row)}
                    aria-label={`Select ${row.name}`}
                />
            ),
            ignoreRowClick: true,
        },
        {
            name: "Name",
            selector: (row) => row.name,
            sortable: true,
            cell: (row) => (
                <div className="d-flex align-items-center">
                    <span className="w-30px h-30px me-2 d-flex align-items-center justify-content-center rounded-circle border bg-color-f2f2f2">
                        <i className="fa fa-image"></i>
                    </span>
                    <span>{row.name}</span>
                </div>
            ),
        },
        {
            name: "Description",
            selector: (row) => row.description,
            sortable: true,
            grow: 2,
        },
        {
            name: "Activity",
            selector: (row) => row.updated_at,
            sortable: true,
            width: "250px",
            cell: (row) => (
                <OverlayTrigger
                    placement="top"
                    overlay={
                        <Tooltip>
                            <div>
                                Created by {row.created_by?.name || "Unknown"}{" "}
                                at {longDateString(row.created_at)}
                            </div>
                            <div>
                                Modified by {row.updated_by?.name || "Unknown"}{" "}
                                at {longDateString(row.updated_at)}
                            </div>
                        </Tooltip>
                    }
                >
                    <div style={{ fontSize: "0.85rem" }}>
                        {row.updated_by?.name || "Unknown"} at{" "}
                        {longDateString(row.updated_at)}
                    </div>
                </OverlayTrigger>
            ),
        },
    ];

    return (
        <DataTable
            columns={columns}
            data={filteredItems}
            highlightOnHover
            striped
            responsive
            pagination
            dense
        />
    );
}

export default PartsListingView;
